// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\RecurringBatchChange\ApiRecurringBatchChange.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { PortCallChange, PortCallChangeData, PortCallChangeOptions } from 'data/models/PortCallChange';
import { PortCallDeletion, PortCallDeletionData, PortCallDeletionOptions } from 'data/models/PortCallDeletion';
import { RecurringBatch, RecurringBatchData, RecurringBatchOptions } from 'data/models/RecurringBatch';
import { CreationRecipient } from 'server/enums/PortCallChange';
import { RecurringBatchChangeType } from 'server/enums/RecurringBatchChangeType';

// RecurringBatchChangeData is the class that RecurringBatchChange serializes to/from
export interface RecurringBatchChangeData {
    Id : number;
	
    Batch : RecurringBatchData | null;
    BatchId : number;
    Event : EventData | null;
    EventId : number;
    PortCallDeletions : PortCallDeletionData[] | null;
    ReservationChanges : PortCallChangeData[] | null;
	
    OldPortCallCount : number;
    Recipient : CreationRecipient;
    Type : RecurringBatchChangeType;
}

// RecurringBatchChangeOptions is the class which may be passed to the RecurringBatchChange constructor to define optional initial data values
export interface RecurringBatchChangeOptions {
    Id : number;
	
    Batch? : RecurringBatchOptions | null;
    BatchId? : number;
    Event? : EventOptions | null;
    EventId? : number;
    PortCallDeletions? : PortCallDeletionOptions[] | null;
    ReservationChanges? : PortCallChangeOptions[] | null;
	
    OldPortCallCount? : number;
    Recipient? : CreationRecipient;
    Type? : RecurringBatchChangeType;
}

export class RecurringBatchChange {
    public Id : DataSignal<number>;
	
    public Batch : DataSignal<RecurringBatch | null>;
    public BatchId : DataSignal<number>;
    public Event : DataSignal<Event | null>;
    public EventId : DataSignal<number>;
    public PortCallDeletions : SDataArray<PortCallDeletion>;
    public ReservationChanges : SDataArray<PortCallChange>;
	
    public OldPortCallCount : DataSignal<number>;
    public Recipient : DataSignal<CreationRecipient>;
    public Type : DataSignal<RecurringBatchChangeType>;

    constructor();
    constructor(data : RecurringBatchChangeOptions);
    constructor(data: RecurringBatchChangeOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Batch = S.value<RecurringBatch | null>(null);
        this.BatchId = jsonableObservable(S.value<number>(data && data.BatchId !== undefined ? data.BatchId : 0));
        this.Event = S.value<Event | null>(null);
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.PortCallDeletions = SArray<PortCallDeletion>([]);
        this.ReservationChanges = SArray<PortCallChange>([]);
	    
        this.OldPortCallCount = jsonableObservable(S.value<number>(data && data.OldPortCallCount !== undefined ? data.OldPortCallCount : 0));
        this.Recipient = jsonableObservable(S.value<CreationRecipient>(data && data.Recipient !== undefined ? data.Recipient : 0));
        this.Type = jsonableObservable(S.value<RecurringBatchChangeType>(data && data.Type !== undefined ? data.Type : 0));
    }

    static key(obj : RecurringBatchChange) {
        return obj.Id();
    }
    
    static dataKey(obj : RecurringBatchChangeOptions) {
        return obj.Id;
    }

    static update(obj : RecurringBatchChange, data : RecurringBatchChangeOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.BatchId !== undefined) obj.BatchId(data.BatchId);
            if (data.EventId !== undefined) obj.EventId(data.EventId);
	        
            if (data.OldPortCallCount !== undefined) obj.OldPortCallCount(data.OldPortCallCount);
            if (data.Recipient !== undefined) obj.Recipient(data.Recipient);
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/RecurringBatchChange.ts